/* Copyright (C) 2019 SmartboxTv S.A. - All rights reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Erasmo Marín <emarin@smartboxtv.com>
 */

import { observable, action, ObservableMap, flow } from 'mobx';
import fetch from '../fetch';
import ErrorsStore from './errorsStore';

const faqs = [
    {
        _id: 'getting-started',
        title: {
            original: 'Getting Started',
            es: 'Primeros pasos',
        },
        description: {
            original: 'Try this simple tutorials and start your video business today!',
            es: '¡Prueba estos simples tutoriales y comienza tu negocio de videos hoy!',
        },
        articles: [
            {
                title: {
                    original: 'Getting started with Nunchee',
                    es: 'Comenzando en Nunchee',
                },
                _id: '1R0P8a2Q1yBvEHaQYsGHVwHwKsw_28VHAhmmKEdXH5NY',
            },
            {
                title: {
                    original: 'How to administrate users in Nunchee?',
                    es: 'Cómo administrar usuarios en Nunchee?',
                },
                _id: '1Aa-x6DZ7R9kAiSCivKFcUzHJt3waI7WnLGKCEfLKhPg',
            },
            {
                title: {
                    original: 'How many videos can my users watch with my plan streaming quote?',
                    es: 'Cuántos videos pueden ver mis usuarios con la cuota actual de mi plan?',
                },
                _id: '1sCKbQsUQmTzIrhQSKYqzq3p5AUtF2hQ1C6J_B68IJe0',
            },
        ],
    },
    {
        _id: 'manage-content',
        title: {
            original: 'Manage Content',
            es: 'Administrar contenido',
        },
        description: {
            original: 'All you need to know in order to manage your content!',
            es: 'Todo lo que necesitas saber para administrar tu contenido',
        },
        articles: [
            {
                title: {
                    original: 'How to upload content?',
                    es: 'Cómo subir contenidos?',
                },
                _id: '1gnO3FWii6uzY-tgEicjrf2DevDlfNnkBJ-U7TbXZAuY',
            },
            {
                title: {
                    original: 'Creating assets categories & types in Nunchee',
                    es: 'Creando categorías y tipos de contenido en Nunchee',
                },
                _id: '1BYlpRZK3xwCpuAwbuTcXxznVC0OuvVIM_Ya7jyHCWJA',
            },
            {
                title: {
                    original: 'What is Staff? How to add new Staff?',
                    es: 'Qué es el Staff? Cómo agregar nuevo Staff?',
                },
                _id: '1SYraFfoQIJxfvDUVlPjYrh32z7vrqxbjlneE3lXXor4',
            },
            {
                title: {
                    original: 'What images to use in your Apps?',
                    es: 'Qué imágenes usar en tus aplicaciones?',
                },
                _id: '1hT6znWwhB776yxEJ3HIFvGMY4Vq-8QOX2ysdNN2G1CE',
            },
            {
                title: {
                    original: 'Sort your playlist',
                    es: 'Ordena tus playlists',
                },
                _id: '13MARY2GOembCoBDdZfsfGDjsmZDUaJVwbfAo-J0LIwU',
            },
            {
                title: {
                    original: 'How to use Access Group in Nunchee?',
                    es: '¿Cómo usar Grupos de Accesso en Nunchee?',
                },
                _id: '1C8uWjpH9V7NxHsm3XLikjcSTRFyzwo7UWvkso29oYWM',
            },
        ],
    },
    {
        _id: 'nunchee-app-builder',
        title: {
            original: 'Nunchee App Builder',
            es: 'El App Builder de Nunchee',
        },
        description: {
            original: 'This is were magic happens!',
            es: '¡Donde la magia ocurre!',
        },
        articles: [
            {
                title: {
                    original: 'How to configure and publish your branded apps?',
                    es: '¿Cómo configurar y publicar aplicaciones con tu marca?',
                },
                _id: '1LIxp0v-z7G7P1eCWXyTgVyHtgGPBEcMs4-YehssorFA',
            },
            {
                title: {
                    original: 'How long it would take to publish my branded apps?',
                    es: '¿Cuanto se demorará en publicar mi aplicación?',
                },
                _id: '1-_PTADpNO_M8FOksnTNWoMJ5GOIePH0G-klJMpIqByA',
            },
            {
                title: {
                    original: 'How can I create a registration process in my video service?',
                    es: '¿Cómo puedo crear un proceso de registro en mi servicio de video?',
                },
                _id: '1WmS28Fu6ZucmULomsdmWufKg_rPSgMe_uPAmEnKKUlE',
            },
            {
                title: {
                    original: 'Change your Subdomain?',
                    es: '¿Cómo cambiar tu subdominio?',
                },
                _id: '1dMzAWtaGD18Tzj9TKeKXqBnHe_esffHj10fxSWKUZRs',
            },
            {
                title: {
                    original: 'What changes will require an App Resubmission?',
                    es: '¿Qué cambios requerirán una re-publicación de tu aplicación?',
                },
                _id: '11aecL8XC5zoHyKhE3v-hUu86_5rWCIOzyjLH6Ho8Xl8',
            },
        ],
    },
    {
        _id: 'nunchee-apps',
        title: {
            original: 'Nunchee Apps',
            es: 'Aplicaciones de Nunchee',
        },
        description: {
            original: 'Meet all the members of the family!',
            es: 'Conoce todos los miembros de la familia!',
        },
        articles: [
            {
                title: {
                    original: 'What Requires an App Resubmission?',
                    es: '¿Qué requiere un reenvío de tu aplicación?',
                },
                _id: '11aecL8XC5zoHyKhE3v-hUu86_5rWCIOzyjLH6Ho8Xl8',
            },
        ],
    },
    {
        _id: 'FAQ',
        title: {
            original: 'FAQ',
        },
        description: {
            original: 'Still have more questions? Shot us an email and we`ll get back to you!',
            es: '¿Aún tienes preguntas? Cóntáctanos con nosotros y te responderemos a la brevedad!',
        },
        articles: [],
    },
    {
        _id: 'managing-access-groups',
        title: {
            original: 'Managing Access Groups',
            es: 'Administrando Grupos de Acceso',
        },
        description: {
            original: 'One of our main features. Come on in, and learn a bit more!',
            es: 'Una de nuestras principales características. ¡Entra y aprende un poco más!',
        },
        articles: [
            {
                title: {
                    original: 'How to create Access Group in Nunchee?',
                    es: '¿Cómo crear un access group en Nunchee?',
                },
                _id: '1C8uWjpH9V7NxHsm3XLikjcSTRFyzwo7UWvkso29oYWM',
            },
        ],
    },
];

class FAQStore {
    @observable
    details = new ObservableMap();

    constructor() {
        this.faqs = faqs;
    }

    @action
    reset = () => {
        this.details.clear();
    };

    @action.bound
    getTutorial = flow(function*({ _id }) {
        try {
            const detail = yield fetch.get({
                url: `/api/tutorial/${_id}`,
                params: {},
            });
            /*let html = detail.html.replace(/\\"/g, '"');
      let tmp = document.createElement('DIV');
      tmp.innerHTML = html;
      detail.html = tmp.querySelector("body").innerHTML;*/
            this.details.set(_id, detail);
        } catch (e) {
            ErrorsStore.addError(e, 'There was an error fetching tutorial');
            console.warn(e);
        }
    });
}

export default new FAQStore();
